/*
    ⚠ If you're going to add a top-level color property (like `black`, 'blue', etc.)
    you'll need to add it to design token stories in 'src\docs\DESIGN_TOKENS.examples.tsx'
*/

import { secondary } from './secondary';
import { tertiary } from './tertiary';
import { neutral } from './neutral';
import { primary } from './primary';
import { success, error, warning, information } from './alert';

const colors = {
    primary,
    secondary,
    neutral,
    tertiary,
    success,
    error,
    warning,
    information,
    transparent: 'transparent',
    white: neutral.white,
    black: neutral.black,
    'white-fixed': '#FFFFFF',
    blackAlpha: {
        50: 'rgba(33, 37, 41, 0.05)',
        100: 'rgba(33, 37, 41, 0.1)',
        200: 'rgba(33, 37, 41, 0.2)',
        300: 'rgba(33, 37, 41, 0.3)',
        400: 'rgba(33, 37, 41, 0.4)',
        500: 'rgba(33, 37, 41, 0.5)',
        600: 'rgba(33, 37, 41, 0.6)',
        700: 'rgba(33, 37, 41, 0.7)',
        800: 'rgba(33, 37, 41, 0.8)',
        900: 'rgba(33, 37, 41, 0.9)',
    },
};

export type Colors = typeof colors & typeof colors;

export default colors;
